import React, {useState} from 'react';

function EditCardsForm({card, handleUpdateCard}) {
    const [cardNo, setCardNo] = useState(card.cardNo);
          const [expiryDate, setExpiryDate] = useState(card.expiryDate);
          const [balance, setBalance] = useState(card.balance);
          const [totalRemaining, setTotalRemaining] = useState(card.totalRemaining);
          const [categoryId, setCategoryId] = useState(card.categoryId);
    
          const handleSubmit = (e) => {
            e.preventDefault();
            const updatedCard = {
                cardNo,
                expiryDate,
                balance,
                totalRemaining,
                categoryId,
            };
            handleUpdateCard(updatedCard);
          };
  return (
    <form onSubmit={handleSubmit}>
      <div className="form-row">
        <div className="form-group">
          <label> Numero Carte</label>
          <input
            type="text"
            value={cardNo}
            onChange={(e) => setCardNo(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label>Date d'expiration :</label>
          <input
            type="date"
            value={expiryDate}
            onChange={(e) => setExpiryDate(e.target.value)}
          />
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label> Balance</label>
          <input
            type="text"
            value={balance}
            onChange={(e) => setBalance(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label>Categorie Carte:</label>
          <input
            type="text"
            value={categoryId}
            onChange={(e) => setCategoryId(e.target.value)}
          />
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label> totalRemaining</label>
          <input
          type="text"
          value={totalRemaining}
          onChange={(e) => setTotalRemaining(e.target.value)}
        />
        </div>
      </div>
      <div className="flex justify-end">
        <button type="submit">Mettre à jour</button>
      </div>
    </form>
  )
}

export default EditCardsForm